import CityPageTemplate from './CityPageTemplate';

export default function WinterSpringsPage() {
  return (
    <CityPageTemplate
      city="Winter Springs"
      county="Seminole"
      slug="winter-springs"
      zipCodes={['32708', '32719']}
      neighborhoods={['Tuscawilla', 'Highlands', 'Oak Forest', 'Winter Springs Town Center', "Hawk's Reserve"]}
      localContext="Serving Winter Springs' Tuscawilla golf communities and Town Center neighborhoods, where families expect every room done right."
      metaDescription="Professional residential and commercial cleaning services in Winter Springs, FL. Serving ZIP codes 32708 & 32719. We Bring the Boom to Every Room. Call SOTSVC today!"
    />
  );
}
